import { useBrandOptions } from '~/components/kiosk/kiosk-ten-dlc/composables/useBrandOptions';
import { adminTenDlcClient } from '~/services';
import type { TcrBrand } from '~/services/adminTenDlcClient.types';

type BrandOption = { label: string; value: string };

const toOption = (brand: TcrBrand): BrandOption => ({
    value: brand.brand_id,
    label: null === brand.display_name ? brand.brand_id : `${brand.brand_id} - ${brand.display_name}`,
});

export const useTcrBrandOptions = (selectedBrandId: () => string | undefined) =>
    useBrandOptions(
        selectedBrandId,
        (query) => adminTenDlcClient.getTcrBrands({ query }).then((response) => response.data.data.map(toOption)),
        (brandId) =>
            adminTenDlcClient.getTcrBrands({ brand_ids: [brandId] }).then((response) => {
                const brand = response.data.data.find((candidate) => candidate.brand_id === brandId);

                return undefined === brand ? undefined : toOption(brand);
            })
    );
